export default __webpack_public_path__ + "static/media/play.9abaa0e1.mp3";